import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import urlParams from "@assets/js/url-params";
import PDPCurrentConfigurationInfo from "../PDPCurrentConfigurationInfo";
import { log } from "@assets/js/utils";
import {
  useActiveConfigurationSKU,
  useSkuProductList,
  useActiveProductData,
  useFullFriendlySKU,
  useConfiguringPendingProductData
} from "@store/pdp";

import "./pdp-micro-swatches.scss";

const PDPMicroSwatches = () => {
  const [activeProductData, setActiveProductData] = useActiveProductData();
  const [,setConfiguringPendingProductData] = useConfiguringPendingProductData();
  const [skuProductList] = useSkuProductList();
  const [activeConfigurationSKU, setActiveConfigurationSKU] = useActiveConfigurationSKU();
  const [, setFullFriendlySKU] = useFullFriendlySKU();
  
  const [activeDisplayName, setActiveDisplayName] = useState(activeProductData.displayName)
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();

  const texts = {
    chooseWithNoConfigurator: t("FritzHansen_Project_ConsumersAndProfessionals_PDP_ChooseWithNoConfigurator"),
    designConfigurationButton: t("FritzHansen_Project_ConsumersAndProfessionals_PDP_DesignConfigurationButton"),
    colour: t("FritzHansen_Project_ConsumersAndProfessionals_PDP_Colour")
  };

  useEffect(() => {
    if (activeConfigurationSKU && activeProductData && skuProductList?.length > 0) {
      let item = activeProductData;
      if (item) {
        let newIndex = skuProductList.indexOf(item);
        if (newIndex > -1) {
          setActiveIndex(newIndex);
        }
      }
    }
  }, [activeConfigurationSKU, activeProductData, skuProductList]);

  const clickHandler = (item, index) => {
    setActiveProductData(item);
    setConfiguringPendingProductData(item);
    setActiveConfigurationSKU(item.fullFriendlyItem);
    setFullFriendlySKU(item.fullFriendlyItem);
    setActiveDisplayName(item.displayName);

    setActiveIndex(index);
    urlParams.set({ sku: item.fullFriendlyItem });
  };

  return (
    <>
      {skuProductList && (skuProductList.length > 1 || activeProductData.isSkuWithConfiguration) ? (
        <>
          <div className="pdp-micro-swatches choose-configuration">
            <h4>{skuProductList.length > 1 && texts.chooseWithNoConfigurator}</h4>
            <div className="pdp-micro-swatches__list">
              <div className="pdp-micro-swatches__list__inner hero-selection">
                {skuProductList.length > 1 && skuProductList.map((item, index) => {
                  return (
                    <button
                      onMouseEnter={() => setActiveDisplayName(item.displayName)}
                      onMouseLeave={() => setActiveDisplayName(activeProductData.displayName)}
                      onClick={() => clickHandler(item, index)}
                      to={`?sku=${item.fullFriendlyItem}`}
                      key={`swatch${index}${item.displayName}`}
                      className={`pdp-hero-selection__list-item ${index === activeIndex ? "is-active" : ""
                        }`}
                    >
                      <div>
                        <img src={item.imageUrl ? item.imageUrl : process.env.REACT_APP_PRODUCT_IMAGE_API + "/r/" + item.imageId + "-r2.webp?sw=80&trim=true&bgcolor=efeeeb"} alt="" />
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          {activeDisplayName && <p className="current-selection">
            <strong>{texts.colour} {activeDisplayName}</strong>
            {activeProductData.isSkuWithConfiguration &&<PDPCurrentConfigurationInfo />}
            </p>}  
        </>
      ) : <div className="pdp-micro-swatches__empty"></div>}
    </>
  );
};
PDPMicroSwatches.propTypes = {
  options: PropTypes.array,
};

export default PDPMicroSwatches;
